import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface BenefitState {
  selectedBenefit: string;
  setSelectedBenefit: (benefit: string) => void;
  clearSelectedBenefit: () => void;
  selectedMedicareBenefit: string;
  setSelectedMedicareBenefit: (benefit: string) => void;
  clearSelectedMedicareBenefit: () => void;
  hasAttemptedCheckout: boolean;
  setHasAttemptedCheckout: (value: boolean) => void;
}

const useBenefitStore = create<BenefitState>()(
  persist(
    set => ({
      selectedBenefit: '',
      setSelectedBenefit: benefit => set({ selectedBenefit: benefit }),
      clearSelectedBenefit: () => set({ selectedBenefit: '' }),
      selectedMedicareBenefit: '',
      setSelectedMedicareBenefit: benefit => set({ selectedMedicareBenefit: benefit }),
      clearSelectedMedicareBenefit: () => set({ selectedMedicareBenefit: '' }),
      hasAttemptedCheckout: false,
      setHasAttemptedCheckout: value => set({ hasAttemptedCheckout: value }),
    }),
    {
      name: 'benefit-store',
      partialize: state => ({
        selectedBenefit: state.selectedBenefit,
        selectedMedicareBenefit: state.selectedMedicareBenefit,
      }),
    },
  ),
);

export default useBenefitStore;
